<template>
  <div class="searchable-articles-list">
    <el-input
      v-if="!hideSearch"
      :value="query"
      prefix-icon="el-icon-search"
      class="query-input"
      placeholder="ค้นหา Article"
      clearable
      @input="handleChangeQuery"
    ></el-input>
    <div v-if="hideSearch" class="input-spacer"></div>
    <div class="list-body">
      <div v-if="noResult" class="empty">{{ emptyText }}</div>
      <articles-selector-option
        v-for="item in selectableArticles"
        :key="item.id"
        v-bind="item"
        :can-select="canSelect"
        class="selected-item"
        @select="handleSelectArticle(item)"
      ></articles-selector-option>
      <infinite-loading
        ref="infiniteLoading"
        :identifier="infiniteLoadingIdentifier"
        spinner="spiral"
        @infinite="infiniteHandler"
      >
        <span slot="no-results" />
        <span slot="no-more" />
      </infinite-loading>
    </div>
  </div>
</template>

<script>
import { Input } from "element-ui";
import InfiniteLoading from "vue-infinite-loading";
import ArticlesSelectorOption from "./ArticlesSelectorOption";

export default {
  components: {
    ArticlesSelectorOption,
    "el-input": Input,
    InfiniteLoading,
  },
  props: {
    query: {
      type: String,
      default: "",
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hideSearch: {
      type: Boolean,
      default: false,
    },
    hasMoreArticles: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      infiniteLoadingIdentifier: 0,
    }
  },
  computed: {
    selectableArticles() {
      return this.value
    },
    canSelect() {
      return !this.disabled
    },
    noResult() {
      return this.value.length === 0
    },
    emptyText() {
      if (this.query) {
        return "ไม่พบที่ค้นหา"
      }

      return "ไม่มี Article"
    },
  },
  methods: {
    handleSelectArticle(service) {
      this.$emit("select", service)
    },
    handleChangeQuery(value) {
      this.$emit("queryChange", value)
    },
    infiniteHandler($state) {
      setTimeout(() => {
        if (this.hasMoreArticles) {
          this.$emit("getMoreArticles")
          $state.loaded()
        } else {
          $state.complete()
        }
      }, 1000)
    },
    resetLoading() {
      this.infiniteLoadingIdentifier += 1
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.searchable-articles-list {
  position: relative;

  border: $border;
  border-radius: $border-radius;

  .el-input__inner {
    border: 0;
    border-bottom: $border;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;

    height: 43px;
    line-height: 43px;
  }

  .input-spacer {
    border-bottom: $border;
    height: 43px;
  }

  > .list-body {
    overflow-y: auto;
    height: 500px;
  }

  > .list-body > .empty {
    padding: 20px 0;
    text-align: center;
  }

  .loading-indicator {
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 43px;

    border-bottom-right-radius: $border-radius;

    background: rgba(255, 255, 255, 0.7);

    text-align: center;
    padding: $space;

    &.active {
      display: block;
    }
  }
}

.lds-ring {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid $primary-color;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: $primary-color transparent transparent transparent;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
